import { useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@cnx/common";
import NotificationService from "services/NotificationService";

export const useNotifications = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATIONS],
    queryFn: () => NotificationService.getNotifications(),
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
};

export const useUpdateNotificationStatus = () => {
  const queryClient = useQueryClient();

  const updateNotificationStatus = async (
    notificationId: string,
    { viewed = false, confirmed = false } = {}
  ) => {
    const updateData: {
      viewedDateTime?: Date;
      confirmedDateTime?: Date;
    } = {};
    if (viewed) updateData.viewedDateTime = new Date();
    if (confirmed) updateData.confirmedDateTime = new Date();

    await NotificationService.updateNotificationRecipient(
      notificationId,
      updateData
    );
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS],
    });
  };

  return updateNotificationStatus;
};
